import { useState } from "react";
import { useConfigView } from "../../Config.context";

export const useLandingPage = () => {
  const { config } = useConfigView();
  const navigate = config?.navigateTo;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const onCreateWorkflow = () => {
    navigate && navigate("/main/workflows");
  };

  const onCreateCampaign = () => {
    if (config?.appName === "tinyAlbert") {
      navigate && navigate("/main/campaigns/overview");
    } else {
      navigate && navigate("/main/campaigns");
    }
  };

  return {
    anchorEl,
    open,
    handleMenuOpen,
    handleCloseMenu,
    onCreateCampaign,
    onCreateWorkflow,
  };
};
